import { Container } from "inversify";
import { TYPES } from "./types";
import {
  EmploymentService,
  EmploymentHttpClient,
} from "./services/EmploymentService";
import {
  IEmploymentHttpClient,
  IEmploymentService,
} from "./interfaces/IEmploymentService";
import { JobPositionResource } from "./services/JobPositionResource";
import { ContainerResource } from "./services/ContainerResource";
import { IJobPositionResource } from "./interfaces/IJobPositionResource";
import { IContainerResource } from "./interfaces/IContainerResource";
import { SignalRBuilder } from "./models/signalr/SignalRBuilder";
import { ISignalRService } from "./interfaces/ISignalR";
import { BillingService } from "./services/BillingService";
import { IBillingService } from "./interfaces/IBillingService";
import { OdinAdminService } from "./services/OdinAdminService";
import { IOdinAdminService } from "./interfaces/IOdinAdminService";
import { Store } from "vuex";

const myContainer = new Container();

// Store will be bound after the store is created
myContainer.bind<Store<any>>("Store").toConstantValue(null as any);

myContainer
  .bind<ISignalRService>(TYPES.ISignalRService)
  .toDynamicValue((context) => {
    const store = context.container.get<Store<any>>("Store");
    return new SignalRBuilder(store);
  })
  .inSingletonScope();

myContainer
  .bind<IEmploymentHttpClient>(TYPES.IEmploymentHttpClient)
  .to(EmploymentHttpClient);

myContainer
  .bind<IJobPositionResource>(TYPES.IJobPositionResource)
  .toDynamicValue(() => {
    const client = myContainer.get<IEmploymentHttpClient>(
      TYPES.IEmploymentHttpClient
    );
    return new JobPositionResource(client);
  });
myContainer
  .bind<IContainerResource>(TYPES.IContainerResource)
  .toDynamicValue(() => {
    const client = myContainer.get<IEmploymentHttpClient>(
      TYPES.IEmploymentHttpClient
    );
    return new ContainerResource(client);
  });
myContainer
  .bind<IEmploymentService>(TYPES.IEmploymentService)
  .toDynamicValue((context) => {
    const httpClient = context.container.get<IEmploymentHttpClient>(
      TYPES.IEmploymentHttpClient
    );
    const conainerResource = myContainer.get<IContainerResource>(
      TYPES.IContainerResource
    );
    const positionResource = myContainer.get<IJobPositionResource>(
      TYPES.IJobPositionResource
    );
    return new EmploymentService(
      positionResource,
      conainerResource,
      httpClient
    );
  });

myContainer
  .bind<IBillingService>(TYPES.IBillingService)
  .toDynamicValue((context) => {
    const httpClient = context.container.get<IEmploymentHttpClient>(
      TYPES.IEmploymentHttpClient
    );
    return new BillingService(httpClient);
  });

myContainer
  .bind<IOdinAdminService>(TYPES.IOdinAdminService)
  .toDynamicValue((context) => {
    const httpClient = context.container.get<IEmploymentHttpClient>(
      TYPES.IEmploymentHttpClient
    );
    return new OdinAdminService(httpClient);
  });

export { myContainer };
